
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchAllCollections } from './fetch-all-collections';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import sortBy from 'lodash/sortBy';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-all-collections`;
};

/**
 * `useAllCollections` hook.
 */

function useAllCollections<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchAllCollections(variables);
  }, {
    initialData: options?.initialData
  });

  return {
    ...result,
    data: sortBy(result?.data, ['name'])
  };
}

/**
 * Export `useAllCollections` hook.
 */

export default useAllCollections;
